import React, { useState } from "react"
import * as styles from "./ProjectStatus.module.css"
import ImageModal from "../projects/enchanted/ImageModal"

const ProjectStatus = () => {
  const [activeTab, setActiveTab] = useState("dec2025")
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [selectedImage, setSelectedImage] = useState(null)

  const statusImages = {
    dec2025: [
      "https://billiontags-media.s3.ap-south-1.amazonaws.com/gopalapuram/IMG_0823.jpg",
      "https://billiontags-media.s3.ap-south-1.amazonaws.com/gopalapuram/IMG_0824.jpg",
      "https://billiontags-media.s3.ap-south-1.amazonaws.com/gopalapuram/IMG_0825.jpg",
      "https://billiontags-media.s3.ap-south-1.amazonaws.com/gopalapuram/IMG_0826.jpg",
      "https://billiontags-media.s3.ap-south-1.amazonaws.com/gopalapuram/IMG_0827.jpg",
      "https://billiontags-media.s3.ap-south-1.amazonaws.com/gopalapuram/IMG_0828.jpg",
      "https://billiontags-media.s3.ap-south-1.amazonaws.com/gopalapuram/IMG_0829.jpg",
      "https://billiontags-media.s3.ap-south-1.amazonaws.com/gopalapuram/IMG_0830.jpg"
    ]
  }

  const openModal = (imageSrc, gallery) => {
    const images = statusImages[gallery]
    const imageIndex = images.indexOf(imageSrc)
    setSelectedImage(imageIndex + 1)
    setIsModalOpen(true)
  }

  return (
    <>
      <section className={styles.projectStatusSection2} id="project-status">
        <h2 className={styles.psTitle2}>
          Project <span className={styles.cbr}>Status</span>
        </h2>

        {/* Tabs */}
        <div className={styles.psTabs2}>
          <button
            className={`${styles.psTab2} ${activeTab === "dec2025" ? styles.active : ""}`}
            onClick={() => setActiveTab("dec2025")}
          >
            December 2025
          </button>
          {/* <button
            className={`${styles.psTab2} ${activeTab === "nov2025" ? styles.active : ""}`}
            onClick={() => setActiveTab("nov2025")}
          >
            November 2025
          </button>
          <button
            className={`${styles.psTab2} ${activeTab === "oct2025" ? styles.active : ""}`}
            onClick={() => setActiveTab("oct2025")}
          >
            October 2025
          </button> */}
        </div>

        {/* December Gallery */}
        <div className={`${styles.psGallery2} ${activeTab === "dec2025" ? styles.show : ""}`}>
          {statusImages.dec2025.map((img, index) => (
            <img
              key={index}
              src={img}
              alt={`December ${index + 1}`}
              onClick={() => openModal(img, "dec2025")}
            />
          ))}
        </div>

      </section>

      {/* Image Modal */}
      {isModalOpen && (
        <ImageModal
          imagesArray={statusImages[activeTab]}
          selectedImage={selectedImage}
          setSelectedImage={setSelectedImage}
          showModal={isModalOpen}
          setShowModal={setIsModalOpen}
        />
      )}
    </>
  )
}

export default ProjectStatus
